import React from 'react'
import { connect } from 'react-redux'
import l8n from 'l8n'
import Link from 'components/CustomComponents/Localization/Link'
import Spin from 'antd/lib/spin'

import { activate } from 'ducks/details'
import { getCurrentUser } from 'ducks/app'

const mapStateToProps = (state, props) => ({
  user: getCurrentUser(state),
  isLoading: state.details.activationLoading
})

@connect(mapStateToProps)
class Notice extends React.Component {
  handleClickActivation = event => {
    this.props.dispatch(activate())
    event.preventDefault()
  }

  render() {
    const { user, isLoading } = this.props
    return (
      <Spin spinning={isLoading}>
        {l8n.p_account_inactive_warning}{' '}
        {user.show_message_fill_details &&
          <span><Link to="/details" className="utils__link--underlined" qaId="fill-details-link">{l8n.p_fill_details}</Link>&nbsp;{l8n.p_and}&nbsp;{l8n.p_activate}</span>}
        {user.show_activation_message &&
          <Link to="#" className="utils__link--underlined" onClick={this.handleClickActivation}>{l8n.p_activate}</Link>
        }.
      </Spin>
    )
  }
}

export default Notice



// WEBPACK FOOTER //
// ./src/components/CustomComponents/Notice/index.js